<template>
    <div class="flex flex-col  items-center justify-center">
        <div class="items-center">
            <div class="flex flex-col w-full" :class="phoneScreen.landscape && 'space-y-2 lg:space-y-4 2xl:space-y-8' || 'space-y-4'">
                <div class="flex">
                    <Bg class="w-14 lg:w-16 2xl:w-20" :border="4">
                        <img :src="`${$t('files_url')}img/games/elements/user.svg`" class="w-5 lg:w-7 2xl:w-9" alt="">
                    </Bg>
                    <h1 class="-ml-8 px-10  p-3 rounded-r-full cursor-pointer text-lg md:text-xl lg:text-2xl 2xl:text-4xl  games-elements-bg-light games-elements-border font-bold text-white" @click="start(1)">
                        {{ $t('elements_button_first_game') }}
                    </h1>
                </div>
                <div class="flex">
                    <Bg class="w-14 lg:w-16 2xl:w-20" :border="4">
                        <img :src="`${$t('files_url')}img/games/elements/users.svg`" class="w-5 lg:w-7 2xl:w-9" alt="">
                    </Bg>
                    <h1 class="-ml-8 px-10  p-3 rounded-r-full cursor-pointer text-lg md:text-xl lg:text-2xl 2xl:text-4xl  games-elements-bg-light games-elements-border font-bold text-white" @click="start(2)">
                        {{ $t('elements_button_second_game') }}
                    </h1>
                </div>
                <div class="hidden">
                    <Bg class="w-14 lg:w-16 2xl:w-20" :border="4">
                        <img :src="`${$t('files_url')}img/games/elements/gear.svg`" class="w-5 lg:w-7 2xl:w-9" alt="">
                    </Bg>
                    <h1 class="-ml-8 px-10  p-3 rounded-r-full cursor-pointer text-lg md:text-xl lg:text-2xl 2xl:text-4xl  games-elements-bg-light games-elements-border font-bold text-white" @click="setScreen('options')">
                        {{ $t('elements_button_settings') }}
                    </h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {useScreen} from 'vue-screen'
import Bg from '../other/Bg.vue'

const phoneScreen = useScreen()

const emit = defineEmits(['screen', 'start'])
const setScreen = (screen) => {
    emit('screen', screen)
}

const start = (gamer) => {
    emit('start', gamer)
}
</script>



